export enum Role {
  USER = 'user',
  MANAGER = 'manager',
  SUPPORT = 'support',
  ADMIN = 'admin',
}
